<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <divisoria-descricao
            :titulo="'Checklist'"
            :descricao="'Aqui você visualiza os dados do checklist e define o responsável pelo preenchimento'"
            :show-more="geradoProposta"
            :texto-mostrar="'Visualizar dados'"
            :mostrar-dados="valueInner.mostrarDados"
            @change="alterarMostrar"
          />
        </b-col>
      </b-row>
      <div class="corner">
        <b-row>
          <b-col cols="12">
            <div style="display: flex;align-items: baseline;margin-bottom: 0.5rem;">
              <div class="circle">
                1
              </div>
              <div style="margin-right: 1rem;">
                <legend style="font-size: 14px;">
                  Informe quem irá responder o checklist?</legend>
              </div>
              <b-form-radio-group
                v-model="valueInner.responsavelAResponder"
                :options="tipoResposta"
                :disabled="geradoProposta || value.retornou || valueInner.id > 0"
                class="radio-responsavel ml-50"
                @input="habilitarBotao"
              />
            </div>
          </b-col>
        </b-row>
      </div>

      <div
        v-if="mostrarPerguntaCNPJ"
        class="corner"
      >
        <div
          v-for="(checklist, $index) in valueInner.checklistCNPJ"
          :key="$index"
        >
          <b-row>
            <b-col cols="12">
              <div style="display: flex;align-items: baseline;">
                <div class="circle">
                  2
                </div>
                <span>{{ checklist.descricao }}</span><span
                  v-if="checklist.obrigatorioRegra"
                  style="color: red;margin-left: 0.3rem;"
                >* </span>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-50">
            <b-col cols="12">
              <span style="font-size: 11px;">{{ checklist.complementoRegra }}</span>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <multi-cnpj-input
                ref="multiCnpjInput"
                v-model="checklist.listaRespostas"
                input-style="width: 30%;"
                :disabled="(geradoProposta || value.retornou)"
                @atualizar-cnpjs="atualizarCnpjsEmpresaTipo"
              />
            </b-col>
          </b-row>
        </div>
      </div>

      <div
        v-if="mostrarEscolhaChecklist"
        class="corner"
      >
        <b-row>
          <b-col>
            <div style="display: flex;align-items: baseline;margin-bottom: 0.5rem;">
              <div class="circle">
                {{ valueInner.tipoProposta === 'transferencia' ? '3' : '2' }}
              </div>
              <span> Qual o tipo?</span>
              <span style="color: red;margin-left: 0.3rem;">* </span>
            </div>
            <b-select
              v-model="valueInner.tipoEmpresa"
              :options="optionsFilial()"
              :disabled="valueInner.tipoProposta === 'constituicao' ? (geradoProposta || value.retornou) : true"
              @input="carregarTributacoes"
            />
          </b-col>
          <b-col>
            <div style="margin-top: 0.3rem;margin-bottom: 0.55rem;">
              <span>Qual a tributação?</span>
              <span style="color: red;margin-left: 0.3rem;">* </span>
            </div>
            <select-base
              :ref="'tipoTributacao'"
              v-model="valueInner.tributacao"
              class="tributacao"
              :require="valueInner.responsavelAResponder === 'gerenteresponsavel'"
              :label-select="'nome'"
              :carregar="carregarTiposTributacaoChecklist"
              :disabled="desabilitarTributacaoAtividade || geradoProposta || value.retornou"
              @input="alterarPrimeiroAcesso"
            />
          </b-col>
          <b-col>
            <div style="margin-top: 0.3rem;margin-bottom: 0.55rem;">
              <span>Qual a atividade preponderante?</span>
              <span style="color: red;margin-left: 0.3rem;">* </span>
            </div>
            <select-base
              :ref="'tipoAtividade'"
              v-model="valueInner.atividade"
              class="atividade"
              :require="valueInner.responsavelAResponder === 'gerenteresponsavel'"
              :label-select="'nome'"
              :carregar="carregarTipoAtividadeChecklist"
              :disabled="desabilitarTributacaoAtividade || geradoProposta || value.retornou"
              @input="carregarChecklist"
            />
          </b-col>
        </b-row>
      </div>
      <b-row class="mt-50">
        <b-col cols="12">
          <tabela-checklist
            ref="tabelaChecklist"
            v-model="valueInner.itemChecklistPropostas"
            :gerado-proposta="geradoProposta"
            :responsavel-a-responder="valueInner.responsavelAResponder"
            :data-proposta="valueInner.dataProposta"
            :show-more="valueInner.mostrarDados"
            :valor-checklist="valueInner.valorTotalChecklist"
            :proposta-id="valueInner.id"
            @valor-checklist="valueInner.valorTotalChecklist = $event"
          />
        </b-col>
      </b-row>
      <b-row style="float: right;">
        <b-col>
          <b-btn
            v-if="valueInner.geradoProposta
              && valueInner.responsavelAResponder === 'gerenteresponsavel' && (!valueInner.dataProposta || valueInner.dataProposta === '')
              && valueInner.propostasPacotes[0].valorPacote !== valueInner.valorTotalChecklist && valueInner.propostasPacotes[0].nivel === 'Nível I - Básico'"
            style="background-color: #ef3434 !important;border-color: #ef3434 !important;"
            size="sm"
            :disabled="(valueInner.dataProposta && valueInner.dataProposta !== '') || valueInner.itemChecklistPropostas.some(som => som.emEdicao)
              || valueInner.propostasPacotes[0].valorPacote === valueInner.valorTotalChecklist"
            @click="atualizarValoresPacotes()"
          >
            Atualizar valor do(s) pacote de honorários
          </b-btn>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.radio-responsavel {
  .custom-control-inline {
    margin-right: 3rem;
  }
}

.tributacao .vs--disabled,
.atividade .vs--disabled {
  .vs__selected {
    color: #b8c2cc !important;
  }
}

.corner {
  border-radius: 12px;
  border: 1px solid #afafaf79;
  // padding: 20px;
  padding: 15px 20px 15px 20px;
  margin-bottom: 1rem;
}

.circle {
  width: 25px;
  height: 25px;
  line-height: 25px;
  border: 1px solid #5e5873;
  border-radius: 50%;
  text-align: center;
  color: #5e5873;
  display: inline-block;
  margin-right: 0.5rem;
}
</style>

<script>
import { generateCode } from '@core/utils/utils'
import apiParametrizacaoChecklist from '@/app-modulo/comercial/parametrizacao-checklist-honorarios/shared/services/api'

export default {
  name: 'ChecklistProposta',
  components: {
    SelectBase: () => import('@/shared/components/select-base/SelectBase.vue'),
    DivisoriaDescricao: () => import('@/shared/components/divisoria-descricao/DivisoriaDescricao.vue'),
    TabelaChecklist: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/checklist-proposta/shared/components/TabelaChecklist.vue'),
    MultiCnpjInput: () => import('@/shared/components/multi-cnpj-input/MultiCnpjInput.vue'),
  },
  props: {
    value: {
      type: Object,
      default: () => { },
    },
    geradoProposta: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tipoResposta: [
        { value: 'pessoaresponsavel', text: 'A Pessoa (Cliente) irá responder o checklist' },
        { value: 'gerenteresponsavel', text: 'O Responsável irá responder o checklist' },
      ],
      atividades: [],
      tributacoes: [],
      valueInner: {},
    }
  },
  computed: {
    desabilitarTributacaoAtividade() {
      return this.valueInner.tipoEmpresa !== 0 && this.valueInner.tipoEmpresa !== 1 && this.valueInner.tipoEmpresa !== 2
    },
    mostrarPerguntaCNPJ() {
      return ((this.valueInner.responsavelAResponder === 'gerenteresponsavel' || (this.valueInner.responsavelAResponder === 'pessoaresponsavel' && (this.geradoProposta || this.valueInner.retornou))) && this.valueInner.checklistCNPJ && this.valueInner.tipoProposta === 'transferencia')
    },
    mostrarEscolhaChecklist() {
      return this.valueInner.responsavelAResponder === 'gerenteresponsavel' || (this.valueInner.responsavelAResponder === 'pessoaresponsavel' && (this.geradoProposta || this.valueInner.retornou))
    },
  },
  watch: {
    value(value, oldValue) {
      if (value !== oldValue) {
        this.valueInner = value
        this.adicionarChecklistCnpj()
      }
    },
  },
  created() {
    this.valueInner = this.value
    if (this.valueInner.responsavelAResponder) {
      this.$emit('habilitar-botao', this.valueInner.responsavelAResponder)
    }
    this.adicionarChecklistCnpj()
  },
  methods: {
    adicionarChecklistCnpj() {
      this.$set(this.valueInner, 'checklistCNPJ', [])
      if ((this.valueInner.responsavelAResponder === 'gerenteresponsavel' && this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas.some(som => som.tipoRegra === 'tags') && this.valueInner.tipoProposta === 'transferencia')
        || (this.valueInner.responsavelAResponder === 'pessoaresponsavel' && (this.geradoProposta || this.valueInner.retornou))) {
        this.valueInner.checklistCNPJ = this.valueInner.itemChecklistPropostas.filter(fil => fil.tipoRegra === 'tags')
        this.valueInner.itemChecklistPropostas = this.valueInner.itemChecklistPropostas.filter(fil => fil.tipoRegra !== 'tags')
      }
    },
    atualizarValoresPacotes() {
      if (this.valueInner.propostasPacotes[0].valorPacote !== this.valueInner.valorTotalChecklist) {
        this.valueInner.propostasPacotes[0].valorPacote = this.valueInner.valorTotalChecklist
        for (let index = 0; index < this.valueInner.propostasPacotes[0].servicos.length; index += 1) {
          this.valueInner.propostasPacotes[0].servicos[index].valorAuditar = this.valueInner.valorTotalChecklist
        }
        this.valueInner.alterouDadosChecklist = true
      }
    },
    alterarMostrar(mostrar) {
      this.valueInner.mostrarDados = mostrar
    },
    carregarTiposTributacaoChecklist() {
      const isFilial = this.valueInner.tipoEmpresa === 1
      return apiParametrizacaoChecklist.getTributacoesCadastradasChecklistFilial(isFilial, this.valueInner.tipoProposta)
    },
    carregarTipoAtividadeChecklist() {
      const isFilial = this.valueInner.tipoEmpresa === 1
      return apiParametrizacaoChecklist.getAtividadesCadastradasChecklist(this.valueInner.tributacao ? this.valueInner.tributacao.id : 0, isFilial, this.valueInner.tipoProposta)
    },
    carregarTributacoes() {
      if (this.valueInner.tipoProposta === 'constituicao') {
        if (this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas.length > 0) {
          this.valueInner.alterouChecklist = true
        }
        this.valueInner.itemChecklistPropostas = []
        this.valueInner.tributacao = null
        this.valueInner.atividade = null
        this.$refs.tipoTributacao.primeiroAcesso = true
      }
    },
    alterarPrimeiroAcesso() {
      if (this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas.length > 0) {
        this.valueInner.alterouChecklist = true
      }
      this.valueInner.itemChecklistPropostas = []
      this.valueInner.atividade = null
      this.$refs.tipoAtividade.primeiroAcesso = true
    },
    habilitarBotao() {
      this.valueInner.itemChecklistPropostas = []
      this.valueInner.checklistCNPJ = []
      if (this.valueInner.responsavelAResponder === 'gerenteresponsavel' && this.valueInner.itemChecklistPropostas
        && !this.valueInner.itemChecklistPropostas.some(som => som.tipoRegra === 'tags') && this.valueInner.tipoProposta === 'transferencia') {
        this.valueInner.checklistCNPJ.push({
          id: 0,
          descricao: 'Informe o CNPJ que será transferido!',
          complementoRegra: 'Em caso de Matriz e Filial informe todos os CNPJ(s) que serão transferidos.',
          tipoRegra: 'tags',
          obrigatorioRegra: true,
          order: this.valueInner.itemChecklistPropostas.length + 1,
          listaRespostas: [],
          code: this.getCode(),
        })
      }
      this.valueInner.tributacao = null
      this.valueInner.atividade = null
      this.valueInner.tipoEmpresa = null

      this.$emit('habilitar-botao', this.valueInner.responsavelAResponder)
    },
    carregarChecklist() {
      if (this.valueInner.itemChecklistPropostas && this.valueInner.itemChecklistPropostas.length > 0) {
        this.valueInner.alterouChecklist = true
      }
      this.valueInner.valorTotalChecklist = 0
      // eslint-disable-next-line no-nested-ternary
      const isFilial = this.valueInner.tipoEmpresa === null ? null : this.valueInner.tipoEmpresa === 1

      if (isFilial !== null && this.valueInner.tributacao && this.valueInner.atividade && this.valueInner.responsavelAResponder != null) {
        apiParametrizacaoChecklist.getChecklist(isFilial, this.valueInner.tributacao.id, this.valueInner.atividade.id, this.valueInner.tipoProposta)
          .then(payload => {
            this.valueInner.itemChecklistPropostas = payload.data

            this.valueInner.itemChecklistPropostas.forEach(each => {
              // eslint-disable-next-line no-param-reassign
              each.code = this.getCode()
            })
            const item = this.valueInner.itemChecklistPropostas.find(fin => fin.automatico)
            if (item) {
              this.valueInner.valorTotalChecklist = item.valor
            }
          })
      }
    },
    getCode() {
      return generateCode()
    },
    optionsFilial() {
      if (this.valueInner.tipoProposta === 'transferencia') {
        return [{ value: null, text: '' }, { value: 1, text: 'Filial' }, { value: 0, text: 'Matriz' }, { value: 2, text: 'Matriz e Filial' }]
      }
      return [{ value: null, text: '' }, { value: 1, text: 'Filial' }, { value: 0, text: 'Matriz' }]
    },
    atualizarCnpjsEmpresaTipo(value) {
      const antigoTipo = this.valueInner.tipoEmpresa
      const filtro = value.filter(fil => fil.includes('Matriz'))
      const filtroFilial = value.filter(fil => fil.includes('Filial'))
      if (filtro.length > 1) {
        this.$erro('Somente é permitido um CNPJ de Matriz por proposta! Contate nossos analistas para mais informações.')
      } else if (filtroFilial.length === 0 && filtro.length === 1) {
        this.$set(this.valueInner, 'tipoEmpresa', 0)
      } else if (filtroFilial.length > 0 && filtro.length === 0) {
        this.$set(this.valueInner, 'tipoEmpresa', 1)
      } else if (filtro.length > 0 && filtroFilial.length > 0) {
        this.$set(this.valueInner, 'tipoEmpresa', 2)
      }

      if (antigoTipo) {
        if ((this.valueInner.tipoEmpresa === 0 || this.valueInner.tipoEmpresa === 2) && antigoTipo === 1) {
          this.limparDadosChecklist(false)
        } else if (this.valueInner.tipoEmpresa === 1 && (antigoTipo === 0 || antigoTipo === 2)) {
          this.limparDadosChecklist(false)
        }
      }

      if (!value || value.length === 0) {
        this.limparDadosChecklist(true)
      }

      const index = this.valueInner.itemChecklistPropostas.findIndex(where => where.tipoRegra === 'tags')
      if (index > -1) {
        this.valueInner.itemChecklistPropostas[index].listaRespostas = value
      }

      if (this.valueInner.checklistCNPJ && this.valueInner.checklistCNPJ[0]) {
        this.valueInner.checklistCNPJ[0].listaRespostas = value
      }
    },
    limparDadosChecklist(limparTipoEmpresa) {
      if (limparTipoEmpresa) {
        this.valueInner.tipoEmpresa = null
      }
      this.valueInner.tributacao = null
      this.valueInner.atividade = null
      this.valueInner.itemChecklistPropostas = []
      this.$refs.tipoTributacao.primeiroAcesso = true
      this.valueInner.alterouChecklist = true
    },
  },
}
</script>
